/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function DevLink(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'DevLink',
      'aria-hidden': true,
      focusable: false,
      width:  28 * scale,
      height: 28 * scale,
      viewBox: '0 0 28 28',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"d":"M10.027 13.12c1.334-1.318 3.661-1.318 4.996 0l.832.82 1.666-1.643-.833-.821a5.9 5.9 0 0 0-4.163-1.703 5.9 5.9 0 0 0-4.164 1.703L5.862 13.94a5.765 5.765 0 0 0 0 8.217 5.9 5.9 0 0 0 4.164 1.699 5.9 5.9 0 0 0 4.164-1.7l.833-.82-1.666-1.644-.832.822a3.575 3.575 0 0 1-4.997 0 3.46 3.46 0 0 1 0-4.931l2.499-2.465z","fill":"currentColor"}),createElement('path', {"d":"m13.81 5.84-.833.821 1.665 1.643.833-.821a3.575 3.575 0 0 1 4.997 0 3.46 3.46 0 0 1 0 4.93l-2.5 2.465c-1.333 1.317-3.66 1.317-4.995 0l-.833-.821L10.48 15.7l.833.821a5.9 5.9 0 0 0 4.163 1.703 5.9 5.9 0 0 0 4.163-1.703l2.5-2.464a5.765 5.765 0 0 0 0-8.217c-2.297-2.266-6.034-2.265-8.328 0z","fill":"currentColor"}))
}
